import { render, staticRenderFns } from "./DashboardMobile.vue?vue&type=template&id=1284bb10&scoped=true&"
import script from "./DashboardMobile.vue?vue&type=script&lang=js&"
export * from "./DashboardMobile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMobile.vue?vue&type=style&index=0&id=1284bb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284bb10",
  null
  
)

export default component.exports